import $ from 'jquery'

function init () {
  $('.corporate-facts-module').each(function () {
    resizeEvent($(this))
  })
}

function resizeEvent (container) {
  heightEqualizer(container)
  mobileResize(container)
  $(window).on('resize', () => {
    heightEqualizer(container)
    mobileResize(container)
  })
}

function heightEqualizer (container) {
  let topContainer = container.find('.top-container'),
    bottomContainer = container.find('.bottom-container'),
    topHeightIdent = topContainer.find('.js-top-height'),
    bottomHeightIdent = bottomContainer.find('.js-bottom-height'),
    topHeight,
    bottomHeight

  topHeightIdent.removeAttr('style')
  bottomHeightIdent.removeAttr('style')

  topHeight = topContainer.height()
  bottomHeight = bottomContainer.height() + parseInt(bottomContainer.css('margin-top').replace('px', ''))

  if (topHeight > bottomHeight) {
    bottomHeightIdent.height((bottomHeightIdent.height() + (topHeight - bottomHeight)) + 'px')
  } else {
    topHeightIdent.height((topHeightIdent.height() + (bottomHeight - topHeight)) + 'px')
  }
}

function mobileResize (container) {
  let imageContainer = container.find('.image-container'),
    image = container.find('.image-container .background-image'),
    contentContainer = container.find('.content-container')

  if ($(window).width() <= 768) {
    imageContainer.css('height', 'auto')

    if (image.height() > contentContainer.height()) {
      contentContainer.css('height', image.height())
    } else {
      contentContainer.css('height', contentContainer.height())
    }
  } else {
    contentContainer.css('height', 'auto')
  }
}

export default {
  init
}
